export default __webpack_public_path__ + "static/media/invoice.25acdb26.svg";